const AppraisalHistoryIcon = (props: any) => {
  return (
    <svg height="16" width="16" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Icons Vincar">
        <path
          id="Vector"
          d="M9.19922 2H4.39922C4.08096 2 3.77573 2.12643 3.55069 2.35147C3.32565 2.57652 3.19922 2.88174 3.19922 3.2V12.8C3.19922 13.1183 3.32565 13.4235 3.55069 13.6485C3.77573 13.8736 4.08096 14 4.39922 14H11.5992C11.9175 14 12.2227 13.8736 12.4477 13.6485C12.6728 13.4235 12.7992 13.1183 12.7992 12.8V5.6L9.19922 2Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path id="Vector_2" d="M9.19922 2V5.6H12.7992" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
        <path
          id="Vector_3"
          d="M10.3996 8.59998H5.59961"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path id="Vector_4" d="M10.3996 11H5.59961" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
        <path
          id="Vector_5"
          d="M6.79961 6.19995H6.19961H5.59961"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  );
};

export default AppraisalHistoryIcon;
